/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { Form, Row, Col } from "antd";
import { MixStyle, media } from "../styles/index";
import { register, clearState } from "../redux/Action/register";
import { Grid, Typography, Input, Button, Loading } from "../core";
const Notify_Utils = require("../helper/utils/Notification");

const layout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};
const Section = styled.section`
  height: 100vh;
  padding: 30px;
  label {
    ${MixStyle.Label}
  }
`;
const Container = styled.div`
  background: #ffffff;
  ${MixStyle.shadow}
  border-radius: 23px;
  padding: 20px 50px;
  ${media.minitablet`padding: 20px 20px;`};
`;
const SignUp = () => {
  let history = useHistory();
  const dispatch = useDispatch();

  let registerReduxState = useSelector((state) => state.register);

  React.useEffect(() => {
    if (registerReduxState.registerSuccess) {
      setIsLoading(false);
      form.resetFields();
      Notify_Utils.openNotificationWithIcon(
        "success",
        registerReduxState.registerSuccess
      );
      dispatch(clearState());
      history.push("/");
    }
    if (registerReduxState.registerFail) {
      setIsLoading(false);
      Notify_Utils.openNotificationWithIcon(
        "error",
        registerReduxState.registerFail
      );
      dispatch(clearState());
    }
  }, [registerReduxState]);
  const [formState, setFormState] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const [form] = Form.useForm();

  const onFinish = (values) => {
    setIsLoading(true);
    dispatch(register(formState));
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const onValuesChange = (changedValues, userData) => {
    const { name, email, password, confirmPassword } = userData;
    setFormState((prev) => ({
      ...prev,
      name,
      email,
      password,
      confirmPassword,
      userType: "Admin",
      approved: true,
    }));
  };
  return (
    <Section>
      <div>{isLoading ? <Loading /> : ""}</div>
      <Grid className="h-100">
        <Row type="flex" align="middle" justify="center" className="h-100">
          <Col md={12} xs={24}>
            <Container>
              <Typography
                as="h1"
                text="Sign up"
                color=" #404E67"
                weight="800"
                align="center"
              />
              <Form
                form={form}
                {...layout}
                name="basic"
                initialValues={{
                  remember: true,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                onValuesChange={onValuesChange}
              >
                <Form.Item
                  label="Name"
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Name!",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  label="Email"
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Email!",
                    },
                  ]}
                >
                  <Input type="Email" />
                </Form.Item>
                <Form.Item
                  label="Password"
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Password!",
                    },
                    {
                      min: 6,
                      message: "Password must be minimum 6 characters.",
                    },
                  ]}
                >
                  <Input type="Password" />
                </Form.Item>
                <Form.Item
                  label="Confirm Password"
                  name="confirmPassword"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Password again!",
                    },
                    {
                      min: 6,
                      message: "Password must be minimum 6 characters.",
                    },
                  ]}
                >
                  <Input type="Password" />
                </Form.Item>
                <Form.Item>
                  <Typography
                    as="h5"
                    align="center"
                    weight="500"
                    color="#233B67"
                  >
                    Already a member? <Link to="/">Login</Link>
                  </Typography>
                </Form.Item>
                <Form.Item>
                  <Button
                    width="187px"
                    bg="#404E67"
                    type="primary"
                    htmlType="submit"
                  >
                    <Typography
                      text="Register"
                      as="h5"
                      noMargin
                      weight="bold"
                      align="center"
                      color="white"
                    />
                  </Button>
                </Form.Item>
              </Form>
            </Container>
          </Col>
        </Row>
      </Grid>
    </Section>
  );
};
export default SignUp;
